// TODO: Using `resolveConfig` adds an excessive payload to the JS bundle.
// Look into how to resolve the config w/o excessive payload

// import resolveConfig from "tailwindcss/resolveConfig"
// import tailwindConfig from "../../tailwind.config.js"

// const fullConfig = resolveConfig(tailwindConfig)

const fullConfig = {
  theme: {
    screens: {
      sm: '600px',
      md: '768px',
      lg: '992px',
      xl: '1200px',
    },
  }
}

export default fullConfig